var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainOnStreetParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4602 20.5903V7.19007L15.4698 7.17228V5.17004C15.4698 4.59451 15.6984 4.04255 16.1054 3.63559C16.5124 3.22863 17.0643 3 17.6399 3H7.09008C6.65062 3 6.21546 3.08671 5.80957 3.25519C5.40369 3.42367 5.03505 3.67058 4.72476 3.9818C4.41448 4.29301 4.16866 4.6624 4.00139 5.06879C3.83413 5.47518 3.7487 5.9106 3.75001 6.35006V20.5903H15.4602Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6334 3H17.8941C18.4712 3 19.0247 3.22925 19.4327 3.63731C19.8408 4.04537 20.07 4.59881 20.07 5.1759V12.0245H15.4575V5.1759C15.4575 4.59881 15.6868 4.04537 16.0948 3.63731C16.5029 3.22925 17.0563 3 17.6334 3V3Z",
    fill: "#33DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 8.4375C6.75 8.12684 7.00184 7.875 7.3125 7.875H12.1875C12.4982 7.875 12.75 8.12684 12.75 8.4375C12.75 8.74816 12.4982 9 12.1875 9L7.3125 9C7.00184 9 6.75 8.74816 6.75 8.4375ZM6.75 11.4375C6.75 11.1268 7.00184 10.875 7.3125 10.875H10.6875C10.9982 10.875 11.25 11.1268 11.25 11.4375C11.25 11.7482 10.9982 12 10.6875 12H7.3125C7.00184 12 6.75 11.7482 6.75 11.4375ZM7.3125 13.875C7.00184 13.875 6.75 14.1268 6.75 14.4375C6.75 14.7482 7.00184 15 7.3125 15H9.1875C9.49816 15 9.75 14.7482 9.75 14.4375C9.75 14.1268 9.49816 13.875 9.1875 13.875H7.3125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainOnStreetParking);
export default __webpack_public_path__ + "static/media/main-on-street-parking.3643a9e5cf3f79c79b48708cdb16b1ea.svg";
export { ForwardRef as ReactComponent };